import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import bannerImage from "../img/thumb/photo-1920x156.jpg";
import IconSuccess from "../img/icons/icon-check.svg";
import toast, { Toaster } from 'react-hot-toast';
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import Select from 'react-select'

export default function Register(prop) {
    let navigate = useNavigate();
    let {slug} = useParams();

    let [passwordInputType, setPasswordInputType] = React.useState('password');
    let [confirmPasswordInputType, setConfirmPasswordInputType] = React.useState('password');

    let [memberTypeId, setMemberTypeId] = React.useState(Utils.MEMBER_TYPE_REASEARCHER);
    let [departmentTypeId, setDepartmentTypeId] = React.useState(Utils.MEMBER_DEPARTMENT_YES);
    let [department, setDepartment] = React.useState(null);
    let [departmentId, setDepartmentId] = React.useState(null);
    let [appliedResearch, setAppliedResearch] = React.useState(null);
    let [basicResearch, setBasicResearch] = React.useState(null);
    let [prefix, setPrefix] = React.useState(null);
    let [prefixId, setPrefixId] = React.useState(1);
    let [isAccept, setIsAccept] = React.useState(false);
    let [prefixTitle, setPrefixTitle] = React.useState(null);
    let [departmentTitle, setDepartmentTitle] = React.useState(null);
    let [disabledBtn, setDisabledBtn] = React.useState(false);
    let [step, setStep] = React.useState(1);
    let [disabledInput, setDisabledInput] = React.useState(false);
    let [prefixThaid, setPrefixThaid] = React.useState(false);
    let [typeId, setTypeId] = React.useState(Utils.MEMBER_TYPE_RESEARCHER);
    let [businessType, setBusinessType] = React.useState(null);
    let [businessTypeId, setBusinessTypeId] = React.useState(null);

    //General
    let refIdcard = React.useRef();
    let refFirstname = React.useRef();
    let refLastname = React.useRef();
    let refEmail = React.useRef();
    let refPhone = React.useRef();
    let refPassword = React.useRef();
    let refConfirmPassword = React.useRef();

    //Cyber
    let [businessTypeTitle, setBusinessTypeTitle] = React.useState(null);
    let refBusinessNo = React.useRef();
    let refBusinessName = React.useRef();
    let refBusinessAddress = React.useRef();
    let refBusinessEmail = React.useRef();
    let refBusinessPhone = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'ลงทะเบียนผู้ใช้งาน | NCSA';

        if(prop.member) {
            navigate((prop.lang === 'en' ? '/en':'/') + 'profile');
        }

        (async function() {
            try {
                const resBusinessType = await Utils.getBusinessType();
                setBusinessType(resBusinessType);

                const resDepartment = await Utils.getDepartment();
                setDepartment(resDepartment);

                const resPrefix = await Utils.getPrefix();
                setPrefix(resPrefix);
                if(resPrefix) {
                    let prefixCheck = resPrefix?.rows.filter(e => e.id === 1)[0];
                    setPrefixTitle(prefixCheck.title);
                    setPrefixId(prefixCheck.id);
                }

                //region geo
                const resProvince = await Utils.getProvince();
                setProvince(resProvince);
                //endregion

                if(slug && slug !== 'success') {
                    let decode = Utils.decodeItem(slug);
                    let pid = decode.pid;
                    let title_th = decode.titleTh;
                    let given_name = decode.given_name;
                    let family_name = decode.family_name;
                    let title_en = decode.titleEn;
                    let given_name_en = decode.given_name_en;
                    let family_name_en = decode.family_name_en;
                    refIdcard.current.value = pid;
                    refFirstname.current.value = given_name;
                    refLastname.current.value = family_name;
                    setDisabledInput(true);
                    if(resPrefix) {
                        let prefixCheck = resPrefix?.rows.filter(e => e.title === title_th)[0];
                        if(prefixCheck) {
                            setPrefixTitle(prefixCheck.title);
                            setPrefixId(prefixCheck.id);
                            setPrefixThaid(true);
                        }
                    }
                }

            } catch (e) {
                //
            }
        })();
    }, []);

    const onReset = () => {
        refIdcard.current.value = '';
        refFirstname.current.value = '';
        refLastname.current.value = '';
        refEmail.current.value = '';
        refPhone.current.value = '';

        refBusinessNo.current.value = '';
        refBusinessName.current.value = '';
        refBusinessAddress.current.value = '';
        refBusinessEmail.current.value = '';
        refBusinessPhone.current.value = '';
    };

    const onNextToStep2 = async () => {
        let idcard = refIdcard.current.value;
        let firstname = refFirstname.current.value;
        let lastname = refLastname.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;
        let zipcode = refZipcode.current.value;

        let businessNo = refBusinessNo.current.value;
        let businessName = refBusinessName.current.value;
        let businessAddress = refBusinessAddress.current.value;
        let businessEmail = refBusinessEmail.current.value;
        let businessPhone = refBusinessPhone.current.value;

        if(typeId === Utils.MEMBER_TYPE_RESEARCHER && departmentTypeId === Utils.MEMBER_DEPARTMENT_YES && !departmentId) {
            toast.error(prop.lang === 'en' ? 'Please specify department':'กรุณาระบุ กระทรวง/สังกัด');
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !businessTypeId) {
            toast.error('กรุณาระบุ ประเภท');
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !businessNo && (businessTypeId === Utils.BUSINESS_TYPE_LEGAL || businessTypeId === Utils.BUSINESS_TYPE_GROUP)) {
            toast.error(prop.lang === 'en' ? 'Please specify Business No':'กรุณาระบุ หมายเลขนิติบุคคล');
            refBusinessNo.current.focus();
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !businessName) {
            toast.error(prop.lang === 'en' ? 'Please specify Business Name':'กรุณาระบุ ชื่อหน่วยงาน/บริษัท/คณะบุคคล/บุคคล');
            refBusinessName.current.focus();
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !businessAddress) {
            toast.error(prop.lang === 'en' ? 'Please specify Business Address':'กรุณาระบุ ที่อยู่จดทะเบียน');
            refBusinessAddress.current.focus();
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !provinceId) {
            toast.error('กรุณาเลือก จังหวัด');
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !amphurId) {
            toast.error('กรุณาเลือก เขต/อำเภอ');
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && !districtId) {
            toast.error('กรุณาเลือก แขวง/ตำบล');
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && (!zipcode || isNaN(zipcode) || zipcode.length !== 5)) {
            toast.error('กรุณาระบุ รหัสไปรษณีย์ ตัวเลข 5 หลัก');
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && (!businessEmail || !Utils.validateEmail.test(businessEmail))) {
            toast.error(prop.lang === 'en' ? 'Please specify Business Address':'กรุณาระบุ รูปแบบอีเมล หน่วยงาน/บริษัท ให้ถูกต้อง');
            refBusinessEmail.current.focus();
        }
        else if(typeId === Utils.MEMBER_TYPE_BUSINESS && businessPhone === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Business Address':'กรุณาระบุ เบอร์โทรศัพท์ หน่วยงาน/บริษัท');
            refBusinessPhone.current.focus();
        }

        else if(!idcard || isNaN(idcard) || idcard.length !== 13) {
            toast.error(prop.lang === 'en' ? 'Please specify 13-digit national ID number.':'กรุณาระบุ ระบุเลขประจำตัวประชาชน ตัวเลข 13 หลัก');
            refIdcard.current.focus();
        }
        else if(!prefixId) {
            toast.error(prop.lang === 'en' ? 'Please specify Prefix':'กรุณาระบุ คำนำหน้านาม');
        }
        else if(firstname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Firstname':'กรุณาระบุ ชื่อจริง');
            refFirstname.current.focus();
        }
        else if(lastname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Lastname':'กรุณาระบุ นามสกุล');
            refLastname.current.focus();
        }
        else if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refEmail.current.focus();
        }
        else if(!phone || isNaN(phone) || phone.length !== 10) {
            toast.error(prop.lang === 'en' ? 'Please specify 10-digit Phone number.':'กรุณาระบุ ระบุเบอร์โทรศัพท์ ตัวเลข 10 หลัก');
            refPhone.current.focus();
        }
        else {
            const result = await Utils.checkExistingMemberEmail(email);
            if(result.email) {
                toast.error(prop.lang === 'en' ? 'Email already exists':'ขออภัย อีเมลนี้ถูกใช้งานไปแล้ว กรุณาระบุอีเมลใหม่');
            }
            else if(result.status === 'delete_account') {
                toast.error(prop.lang === 'en' ? 'Sorry, this account is in Deleted status. Please contact the administrator.':'ขออภัย บัญชีนี้อยู่ในสถานะ ลบบัญชี กรุณาติดต่อผู้ดูแลระบบ');
            }
            else {
                if(typeId === Utils.MEMBER_TYPE_BUSINESS) {
                    const resultBusinessEmail = await Utils.checkExistingMemberBusinessEmail(businessEmail);
                    const resultBusinessNo = await Utils.checkExistingMemberBusinessNo(businessNo);
                    if(resultBusinessEmail.businessEmail) {
                        toast.error(prop.lang === 'en' ? 'Business Email already exists':'ขออภัย อีเมลของหน่วยงาน นี้ถูกใช้งานไปแล้ว กรุณาระบุใหม่');
                        refBusinessEmail.current.focus();
                    }
                    else if(resultBusinessNo.businessNo) {
                        toast.error(prop.lang === 'en' ? 'Business Number already exists':'ขออภัย หมายเลขนิติบุคคลนี้ถูกใช้งานไปแล้ว กรุณาระบุใหม่');
                        refBusinessNo.current.focus();
                    }
                    else {
                        setStep(2);
                    }
                }
                else {
                    setStep(2);
                }
            }
        }
    };

    const onPrevToStep1 = () => {
        window.scrollTo(0, 0);
        setStep(1);
    };

    const onNextToStep3 = () => {
        let password = refPassword.current.value;
        let confirmPassword = refConfirmPassword.current.value;

        if(password === '' || !Utils.strengthPassword.test(password)) {
            toast.error(prop.lang === 'en' ? 'Please enter your password according to the specified format':'กรุณาระบุ รหัสผ่าน ตามรูปแบบที่กำหนดไว้');
            refPassword.current.focus();
        }
        else if(confirmPassword === '' || confirmPassword !== password) {
            toast.error(prop.lang === 'en' ? 'Please provide the same password':'กรุณาระบุ รหัสผ่านให้ตรงกัน');
            refConfirmPassword.current.focus();
        }
        else {
            window.scrollTo(0, 0);
            setStep(3);
        }
    };

    const onPrevToStep2 = () => {
        window.scrollTo(0, 0);
        setStep(2);
    };

    const onSubmit = async () => {
        let idcard = refIdcard.current.value;
        let firstname = refFirstname.current.value;
        let lastname = refLastname.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;
        let password = refPassword.current.value;
        let confirmPassword = refConfirmPassword.current.value;
        let zipcode = refZipcode.current.value;

        let businessNo = refBusinessNo.current.value;
        let businessName = refBusinessName.current.value;
        let businessAddress = refBusinessAddress.current.value;
        let businessEmail = refBusinessEmail.current.value;
        let businessPhone = refBusinessPhone.current.value;

        if(!isAccept) {
            toast.error(prop.lang === 'en' ? 'Please click to accept the terms and conditions':'กรุณากดยอมรับเงื่อนไขและข้อตกลง');
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันสมัครสมาชิก ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setDisabledBtn(true);
                            let createdAt = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
                            let param = {
                                typeId: typeId,
                                memberTypeId: memberTypeId,
                                departmentTypeId: departmentTypeId,
                                departmentId: departmentId,
                                basicResearch: basicResearch ? 1:null,
                                appliedResearch: appliedResearch ? 1:null,
                                idcard: idcard,
                                prefixId: prefixId,
                                firstname: firstname,
                                lastname: lastname,
                                email: email,
                                phone: phone,
                                password: password,
                                createdAt: createdAt,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };

                            if(typeId === Utils.MEMBER_TYPE_BUSINESS) {
                                param.provinceId = provinceId.id;
                                param.amphurId = amphurId.id;
                                param.districtId = districtId.id;
                                param.zipcode = zipcode;
                                param.businessTypeId = businessTypeId;
                                param.businessNo = businessNo;
                                param.businessName = businessName;
                                param.businessAddress = businessAddress;
                                param.businessEmail = businessEmail;
                                param.businessPhone = businessPhone;
                            }

                            const result = await createMember(param);
                            if(result) {
                                if(result.status === 'success') {
                                    let param = {
                                        name: firstname + ' ' + lastname,
                                        email: email,
                                        email_admin: result.email_admin,
                                        phone: phone,
                                        create_date: createdAt
                                    };
                                    await sendEmail(param);
                                    setDisabledBtn(false);
                                    navigate((prop.lang === 'en' ? '/en':'/') + 'register/success');
                                }
                                else if(result.status === 'email') {
                                    toast.error(prop.lang === 'en' ? 'Email already exists':'ขออภัย อีเมลนี้ถูกใช้งานไปแล้ว กรุณาระบุอีเมลใหม่');
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ไม่สามารถลงทะเบียนได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function createMember(param) {
        const response = await fetch(Config.apiUrl +'/member/createMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangePrefix = (x) => {
        setPrefixTitle(x.target.value ? prefix?.rows.filter(e => parseInt(e.id) === parseInt(x.target.value))[0]?.title : '');
        setPrefixId(x.target.value);
    };

    const onChangeDepartment = (x) => {
        setDepartmentTitle(x.target.value ? department?.rows.filter(e => parseInt(e.id) === parseInt(x.target.value))[0]?.title : '');
        setDepartmentId(x.target.value);
    };

    const onChangeBusinessType = (x) => {
        if(x) {
            let id = parseInt(x.target.value);
            setBusinessTypeTitle(x.target.value ? businessType?.filter(e => e.id === id)[0]?.title : '');
            setBusinessTypeId(id);
            if(id === Utils.BUSINESS_TYPE_PERSON) {
                refBusinessNo.current.value = '';
            }
        }
    };

    let [validPassword, setValidPassword] = React.useState(true);
    const onKeyUpPassword = () => {
        if(refPassword.current.value) {
            let valid = Utils.strengthPassword.test(refPassword.current.value);
            setValidPassword(valid);
        }
        else {
            setValidPassword(true);
        }
    };

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_register.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //region geo
    let [province, setProvince] = React.useState(null);
    let [provinceId, setProvinceId] = React.useState(null);
    let [amphur, setAmphur] = React.useState(null);
    let [amphurId, setAmphurId] = React.useState(null);
    let [district, setDistrict] = React.useState(null);
    let [districtId, setDistrictId] = React.useState(null);
    let refZipcode = React.useRef();

    const onChangeProvince = async (obj) => {
        setProvinceId(obj);
        setAmphur(null);
        setAmphurId(null);
        setDistrict(null);
        setDistrictId(null);
        refZipcode.current.value = '';
        if(obj) {
            let resAmphur = await Utils.getAmphur(obj.id);
            setAmphur(resAmphur);
        }
    };
    const onChangeAmphur = async (obj) => {
        setAmphurId(obj);
        setDistrict(null);
        setDistrictId(null);
        refZipcode.current.value = '';
        if(obj) {
            let resDistrict = await Utils.getDistrict(obj.id);
            setDistrict(resDistrict);
        }
    };
    const onChangeDistrict = async (obj) => {
        setDistrictId(obj);
        refZipcode.current.value = '';
        if(obj) {
            let resZipcode = await Utils.getZipcode(obj.id);
            refZipcode.current.value = resZipcode.zipcode;
        }
    };
    //endregion

    return (
        <>
            <div className={"section section-banner small" + (slug === 'success' ? ' d-none':'')}>
                <img src={bannerImage} alt="" />
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Register':'ลงทะเบียนผู้ใช้งาน'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'Register':'ลงทะเบียนผู้ใช้งาน'} </p>
                </div>
            </div>

            <div className="section">
                <div className="container py-2">
                    <div className="card-infos has-shadow-black w-1020" data-aos="fade-in">
                        <div className={"hgroup text-center" + (slug === 'success' ? ' d-none':'')} data-aos="fade-in">
                            <h2 className="my-2">{prop.lang === 'en' ? 'Register':'ลงทะเบียนผู้ใช้งาน'}</h2>
                        </div>

                        <ul className={"nav-steps" + (slug === 'success' ? ' d-none':'')} data-aos="fade-in">
                            <li className={step === 1 ? 'active':''}>
                                <a href="#">
                                    <h3 className="number">1</h3>
                                    <p>{prop.lang === 'en' ? 'Profile':'ข้อมูลส่วนตัว'}</p>
                                </a>
                            </li>

                            <li className={step === 2 ? 'active':''}>
                                <a href="#">
                                    <h3 className="number">2</h3>
                                    <p>{prop.lang === 'en' ? 'Password':'กำหนดรหัสผ่าน'}</p>
                                </a>
                            </li>

                            <li className={step === 3 ? 'active':''}>
                                <a href="#">
                                    <h3 className="number">3</h3>
                                    <p>{prop.lang === 'en' ? 'Confirm':'ยืนยัน'}</p>
                                </a>
                            </li>
                        </ul>

                        <div className={"boxed" + (step === 1 && slug !== 'success' ? '':' d-none' )}>
                            <h6 className="pb-3">{prop.lang === 'en' ? 'Member Type':'ประเภทสมาชิก'}</h6>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-check lg">
                                        <input className="form-check-input" type="radio" id="typeId1" name="typeId" onChange={e => setTypeId(Utils.MEMBER_TYPE_RESEARCHER)} checked={typeId === Utils.MEMBER_TYPE_RESEARCHER} />
                                        <label className="form-check-label" htmlFor="typeId1">{prop.lang === 'en' ? 'Researcher/Entrepreneur/Agency':'นักวิจัย/ผู้ประกอบการ/หน่วยงาน'}</label>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-check lg">
                                        <input className="form-check-input" type="radio" id="typeId2" name="typeId" onChange={e => setTypeId(Utils.MEMBER_TYPE_BUSINESS)} checked={typeId === Utils.MEMBER_TYPE_BUSINESS} />
                                        <label className="form-check-label" htmlFor="typeId2">{prop.lang === 'en' ? 'Cybersecurity Service Provider':'ผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์'}</label>
                                    </div>
                                </div>
                            </div>

                            <div className="py-3">
                                <hr />
                            </div>

                            <div className={typeId === Utils.MEMBER_TYPE_RESEARCHER ? '':' d-none'}>
                                <h6 className="pb-3">{prop.lang === 'en' ? 'Member Type':'ประเภทนักวิจัย/ผู้ประกอบการ/หน่วยงาน'}</h6>
                                <div className="row">
                                    <div className="col-md-4 col-sm-6">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="radio" id="radio1_1" name="radio1" onChange={e => setMemberTypeId(Utils.MEMBER_TYPE_REASEARCHER)} checked={memberTypeId === Utils.MEMBER_TYPE_REASEARCHER} />
                                            <label className="form-check-label" htmlFor="radio1_1">{prop.lang === 'en' ? 'Researcher':'นักวิจัย'}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-6">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="radio" id="radio1_2" name="radio1" onChange={e => setMemberTypeId(Utils.MEMBER_TYPE_ENTREPRENEUR)} checked={Utils.MEMBER_TYPE_ENTREPRENEUR === memberTypeId} />
                                            <label className="form-check-label" htmlFor="radio1_2">{prop.lang === 'en' ? 'Entrepreneur/Agency':'ผู้ประกอบการ/หน่วยงาน'}</label>
                                        </div>
                                    </div>
                                </div>

                                <h6 className="pb-3 mt-4">{prop.lang === 'en' ? 'Belong To Type':'ประเภทสังกัด'}</h6>
                                <div className="row">
                                    <div className="col-md-4 col-sm-6">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="radio" value="" id="radio2_1" name="radio2" onChange={e => setDepartmentTypeId(Utils.MEMBER_DEPARTMENT_YES)} checked={Utils.MEMBER_DEPARTMENT_YES === departmentTypeId} />
                                            <label className="form-check-label" htmlFor="radio2_1">{prop.lang === 'en' ? 'Specify':'ระบุสังกัด'}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-6">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="radio" value="" id="radio2_2" name="radio2" onChange={e => setDepartmentTypeId(Utils.MEMBER_DEPARTMENT_NO)} checked={Utils.MEMBER_DEPARTMENT_NO === departmentTypeId} />
                                            <label className="form-check-label" htmlFor="radio2_2">{prop.lang === 'en' ? 'Not specified':'ไม่ระบุสังกัด'}</label>
                                        </div>
                                    </div>
                                </div>

                                <h6 className="pb-2 mt-4">{prop.lang === 'en' ? 'Select Department':'กระทรวง/สังกัด'} <span className="star">*</span></h6>
                                <select className="form-select" defaultValue={departmentId} onChange={onChangeDepartment} disabled={departmentTypeId === Utils.MEMBER_DEPARTMENT_NO}>
                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                    {
                                        department !== null && department.count > 0 ?
                                            department.rows.map((row, index) => {
                                                return (
                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                )
                                            }) : ''
                                    }
                                </select>

                                <h6 className="pb-3 mt-4">{prop.lang === 'en' ? 'Research Type':'ประเภทของการวิจัย'}</h6>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="radio3_1" name="radio3" onChange={e => setBasicResearch(!basicResearch)} checked={basicResearch} />
                                            <label className="form-check-label" htmlFor="radio3_1">
                                                {prop.lang === 'en' ? 'Basic Research':'การวิจัยพื้นฐาน (Basic Research)'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-check lg">
                                            <input className="form-check-input" type="checkbox" value="" id="radio3_2" name="radio3" onChange={e => setAppliedResearch(!appliedResearch)} checked={appliedResearch} />
                                            <label className="form-check-label" htmlFor="radio3_2">
                                                {prop.lang === 'en' ? 'Applied Research':'การวิจัยประยุกต์ (Applied Research)'}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={typeId === Utils.MEMBER_TYPE_BUSINESS ? '':' d-none'}>
                                <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Info':'ข้อมูลบริษัท'}</h3>
                                <div className="row g-3">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Type':'ประเภท'} <span className="star">*</span></h6>
                                            <select className="form-select" defaultValue={businessTypeId} onChange={onChangeBusinessType}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    businessType !== null && businessType.length > 0 ?
                                                        businessType.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className={"col-sm-6" + (businessTypeId === Utils.BUSINESS_TYPE_LEGAL || businessTypeId === Utils.BUSINESS_TYPE_GROUP ? '':' d-none')}>
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Number':'หมายเลขนิติบุคคล'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refBusinessNo} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Name':'ชื่อหน่วยงาน/บริษัท/คณะบุคคล/บุคคล'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refBusinessName} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Address':'ที่อยู่จดทะเบียน'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refBusinessAddress} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>จังหวัด <span className="star">*</span></h6>
                                            <Select
                                                isClearable={false}
                                                classNamePrefix="form-select-search"
                                                options={province}
                                                onChange={(event) => onChangeProvince(event)}
                                                value={provinceId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.title}`}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>เขต/อำเภอ <span className="star">*</span></h6>
                                            <Select
                                                isClearable={false}
                                                isDisabled={!amphur}
                                                classNamePrefix="form-select-search"
                                                options={amphur}
                                                onChange={(event) => onChangeAmphur(event)}
                                                value={amphurId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.title}`}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>แขวง/ตำบล <span className="star">*</span></h6>
                                            <Select
                                                isClearable={false}
                                                isDisabled={!district}
                                                classNamePrefix="form-select-search"
                                                options={district}
                                                onChange={(event) => onChangeDistrict(event)}
                                                value={districtId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.title}`}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>รหัสไปรษณีย์ <span className="star">*</span></h6>
                                            <input type="text" className="form-control" id="zipcode" ref={refZipcode} maxLength={5} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Email':'อีเมล'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refBusinessEmail} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Phone':'เบอร์โทรศัพท์'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refBusinessPhone} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="py-3">
                                <hr />
                            </div>

                            <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Profile':'ข้อมูลส่วนตัว'}</h3>
                            <div className="row g-3">
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Id Card Number':'ระบุเลขประจำตัวประชาชน'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refIdcard} placeholder={prop.lang === 'en' ? '13-digit national ID number':'ตัวเลข 13 หลัก'} maxLength={13} disabled={disabledInput} />
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Prefix':'คำนำหน้านาม'} <span className="star">*</span></h6>
                                        <select className="form-select" value={prefixId} onChange={onChangePrefix} disabled={prefixThaid}>
                                            <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                            {
                                                prefix !== null && prefix.count > 0 ?
                                                    prefix.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Firstname':'ชื่อจริง'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refFirstname} maxLength={100} disabled={disabledInput} />
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Lastname':'นามสกุล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refLastname} maxLength={100} disabled={disabledInput} />
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refEmail} placeholder={prop.lang === 'en' ? 'ex. your@mail.com':'เช่น your@mail.com'} maxLength={100} />
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Phone':'หมายเลขโทรศัพท์มือถือ'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refPhone} placeholder={prop.lang === 'en' ? '10-digit national ID number':'ตัวเลข 10 หลัก'} maxLength={10} />
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-gray w-130" type="button" onClick={onReset}>
                                    {prop.lang === 'en' ? 'Reset':'ยกเลิก'}
                                </button>
                                <button className="btn btn-primary w-130" type="button" onClick={onNextToStep2}>
                                    {prop.lang === 'en' ? 'Next':'ถัดไป'}
                                </button>
                            </div>
                        </div>

                        <div className={"boxed" + (step === 2 && slug !== 'success' ? '':' d-none' )}>
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Email':'ชื่อผู้ใช้งาน'}</h6>
                                        <input type="email" className="form-control" value={refEmail.current?.value} disabled />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Password':'รหัสผ่าน'} <span className="star">*</span></h6>
                                        <div className="group">
                                            <span className="icons icon-eye right" onClick={e => {setPasswordInputType(passwordInputType === 'password' ? 'text':'password')}}></span>
                                            <input type={passwordInputType} className="form-control" ref={refPassword} maxLength={20} onKeyUp={onKeyUpPassword} />
                                        </div>
                                        <div className={"alert alert-xs mt-2 mb-0 " + (refPassword.current?.value ? (!validPassword ? 'alert-danger':'alert-success') : 'alert-warning')}>
                                            {Utils.passwordAlert(prop.lang)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Confirm Password':'ยืนยันรหัสผ่าน'} <span className="star">*</span></h6>
                                        <div className="group">
                                            <span className="icons icon-eye right" onClick={e => {setConfirmPasswordInputType(confirmPasswordInputType === 'password' ? 'text':'password')}}></span>
                                            <input type={confirmPasswordInputType} className="form-control" ref={refConfirmPassword} maxLength={20} />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-gray w-130" type="button" onClick={onPrevToStep1}>
                                    {prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}
                                </button>
                                <button className="btn btn-primary w-130" type="button" onClick={onNextToStep3}>
                                    {prop.lang === 'en' ? 'Next':'ถัดไป'}
                                </button>
                            </div>
                        </div>

                        <div className={"boxed" + (step === 3 && slug !== 'success' ? '':' d-none' )}>
                            <table className="table-form-infos">
                                <tbody>
                                {
                                    typeId === Utils.MEMBER_TYPE_BUSINESS ?
                                        <>
                                            <tr>
                                                <th>{prop.lang === 'en' ? 'Business No':'หมายเลขนิติบุคคล'}</th>
                                                <td>{refBusinessNo.current?.value}</td>
                                            </tr>
                                            <tr>
                                                <th>{prop.lang === 'en' ? 'Business Type':'ประเภท'}</th>
                                                <td>{businessTypeTitle}</td>
                                            </tr>
                                            <tr>
                                                <th>{prop.lang === 'en' ? 'Business Name':'ชื่อหน่วยงาน/บริษัท'}</th>
                                                <td>{refBusinessName.current?.value}</td>
                                            </tr>
                                            <tr>
                                                <th>{prop.lang === 'en' ? 'Business Address':'ที่อยู่จดทะเบียน'}</th>
                                                <td>{refBusinessAddress.current?.value}</td>
                                            </tr>
                                            <tr>
                                                <th>{prop.lang === 'en' ? 'Business Email':'อีเมล หน่วยงาน/บริษัท'}</th>
                                                <td>{refBusinessEmail.current?.value}</td>
                                            </tr>
                                            <tr>
                                                <th>{prop.lang === 'en' ? 'Business Phone':'เบอร์โทรศัพท์ หน่วยงาน/บริษัท'}</th>
                                                <td>{refBusinessPhone.current?.value}</td>
                                            </tr>
                                        </> : ''
                                }
                                    <tr>
                                        <th>{prop.lang === 'en' ? 'Id Card':'เลขประจำตัวประชาชน'}</th>
                                        <td>{refIdcard.current?.value}</td>
                                    </tr>
                                {
                                    typeId === Utils.MEMBER_TYPE_RESEARCHER ?
                                        <tr>
                                            <th>{prop.lang === 'en' ? 'Department':'สังกัดหน่วยงาน'}</th>
                                            <td>{departmentTitle}</td>
                                        </tr> : ''
                                }
                                    <tr>
                                        <th>{prop.lang === 'en' ? 'Name':'ชื่อ - นามสกุล'}</th>
                                        <td>{prefixTitle + ' ' + refFirstname.current?.value + ' ' + refLastname.current?.value}</td>
                                    </tr>
                                    <tr>
                                        <th>{prop.lang === 'en' ? 'Email':'อีเมล'}</th>
                                        <td>{refEmail.current?.value}</td>
                                    </tr>
                                    <tr>
                                        <th>{prop.lang === 'en' ? 'Phone':'หมายเลขโทรศัพท์มือถือ'}</th>
                                        <td>{refPhone.current?.value}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className="px-sm-4 py-4">
                                <div className="form-check mt-2">
                                    <input className="form-check-input" type="checkbox" value="" id="check-1" onChange={e => setIsAccept(e.target.checked)} checked={isAccept} />
                                    <label className="form-check-label fw-400 text-black" htmlFor="check-1">
                                        ข้าพเจ้าได้อ่านและทำความเข้าใจ <a href="https://drive.ncsa.or.th/s/7m3fW6bkNMy6LjQ" className="link-primary link-underline" target="_blank">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a> รวมถึงข้อกำหนดและเงื่อนไขแล้ว จึงได้กดยืนยันการสมัครสมาชิกเพื่อยอมรับเงื่อนไขดังกล่าว
                                    </label>
                                </div>
                            </div>

                            <div className="buttons gap-15 p-0 my-sm-4">
                                <button className="btn btn-gray w-130" type="button" onClick={onPrevToStep2}>
                                    {prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}
                                </button>
                                <button className="btn btn-primary w-130" type="button" onClick={onSubmit} disabled={disabledBtn}>
                                    {prop.lang === 'en' ? 'Submit':'ยืนยัน'}
                                </button>
                            </div>
                        </div>

                        <div className={"boxed text-center" + (slug === 'success' ? '':' d-none' )}>
                            <div className="hgroup text-center mb-4" data-aos="fade-in">
                                <div className="my-sm-4">
                                    <img src={IconSuccess} width="100px" height="100px" />
                                </div>
                                <h2 className="my-2 mb-0">{prop.lang === 'en' ? 'Registration successfully':'ลงทะเบียนผู้ใช้งานสำเร็จ'}</h2>
                                <div className="py-3 w-600">
                                    <hr />
                                </div>
                                <p className="fs-16 mb-0">{prop.lang === 'en' ? 'Please return to the login page':'กรุณากลับไปยังหน้าเข้าสู่ระบบ'}</p>
                                <p className="fs-18 fw-500 text-black">{prop.lang === 'en' ? 'You can log in with your user account and the password you set':'ท่านสมารถเข้าสู่ระบบด้วยบัญชีผู้ใช้งาน พร้อมกับรหัสผ่านที่ท่านตั้งไว้'}</p>
                            </div>

                            <div className="boxed" data-aos="fade-in">
                                <div className="buttons gap-15 p-0 my-sm-4">
                                    <NavLink to={prop.lang === 'en' ? '/en/login' : '/login'} className="btn btn-primary w-130">
                                        {prop.lang === 'en' ? 'Login':'เข้าสู่ระบบ'}
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 